module.exports = __webpack_public_path__ + "static/media/1029621.4ade2612.jpg";